import { Injectable } from '@angular/core';
import { getJwtCartId, isJwtWithCartIdUsable } from 'src/app/shared/utils/jwt-token.utils';

const TOKEN_KEY = 'authToken';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private readonly KEY = 'auth_access_token';
  private readonly PLAYER_KEY = 'auth_player_allowed';
  private readonly PLAYER_PROFILE_INCOMPLETE_KEY = 'auth_player_profile_incomplete';

  set(token: string): void {
    localStorage.setItem(this.KEY, token);
  }

  get(): string | null {
    return localStorage.getItem(this.KEY);
  }

  clear(): void {
    localStorage.removeItem(this.KEY);
    localStorage.removeItem(this.PLAYER_KEY);
    localStorage.removeItem(this.PLAYER_PROFILE_INCOMPLETE_KEY);
  }

  has(): boolean {
    return !!this.get();
  }

  getCartId(): string | null {
    return getJwtCartId(this.get());
  }

  hasUsableCartId(): boolean {
    return isJwtWithCartIdUsable(this.get());
  }

  setPlayerAllowed(allowed: boolean): void {
    localStorage.setItem(this.PLAYER_KEY, allowed ? 'true' : 'false');
  }

  isPlayerAllowed(): boolean {
    return localStorage.getItem(this.PLAYER_KEY) === 'true';
  }

  setPlayerProfileIncomplete(incomplete: boolean): void {
    localStorage.setItem(this.PLAYER_PROFILE_INCOMPLETE_KEY, incomplete ? 'true' : 'false');
  }

  isPlayerProfileIncomplete(): boolean {
    return localStorage.getItem(this.PLAYER_PROFILE_INCOMPLETE_KEY) === 'true';
  }

  clearPlayerProfileIncomplete(): void {
    localStorage.removeItem(this.PLAYER_PROFILE_INCOMPLETE_KEY);
  }

  clearPlayerAllowed(): void {
    localStorage.removeItem(this.PLAYER_KEY);
  }
}
